var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        keyboard: false,
        forceRender: true,
        prefixNo: _vm.prefixNo,
        fullscreen: "",
        switchHelp: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrintPro("请购单")
                    },
                  },
                },
                [_vm._v("三联打印-新版")]
              )
            : _vm._e(),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrint("请购单")
                    },
                  },
                },
                [_vm._v("三联打印")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanCheck
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.confirmLoading },
                  on: { click: _vm.handleOkAndCheck },
                },
                [_vm._v("保存并审核")]
              )
            : _vm._e(),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleOkOnly },
            },
            [_vm._v("保存（Ctrl+S）")]
          ),
          !_vm.checkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleWorkflow()
                    },
                  },
                },
                [_vm._v("提交流程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "operTime",
                                  _vm.validatorRules.operTime,
                                ],
                                expression:
                                  "['operTime', validatorRules.operTime]",
                              },
                            ],
                            attrs: { "show-time": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                            "data-step": "2",
                            "data-title": "单据编号",
                            "data-intro":
                              "单据编号自动生成、自动累加、开头是单据类型的首字母缩写，累加的规则是每次打开页面会自动占用一个新的编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["number", _vm.validatorRules.number],
                                expression:
                                  "[ 'number', validatorRules.number ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入单据编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { lg: 6, md: 12, sm: 24 } }),
                  _c("a-col", { attrs: { lg: 6, md: 12, sm: 24 } }),
                ],
                1
              ),
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  id: "billModal",
                  loading: _vm.materialTable.loading,
                  columns: _vm.materialTable.columns,
                  dataSource: _vm.materialTable.dataSource,
                  minWidth: _vm.minWidth,
                  maxHeight: 300,
                  rowNumber: false,
                  rowSelection: _vm.rowCanEdit,
                  actionButton: _vm.rowCanEdit,
                  dragSortAndNumber: _vm.rowCanEdit,
                },
                on: {
                  valueChange: _vm.onValueChange,
                  added: _vm.onAdded,
                  deleted: _vm.onDeleted,
                },
                scopedSlots: _vm._u([
                  {
                    key: "buttonAfter",
                    fn: function () {
                      return [
                        _vm.rowCanEdit
                          ? _c(
                              "a-row",
                              {
                                staticStyle: {
                                  float: "left",
                                  "padding-bottom": "5px",
                                },
                                attrs: {
                                  gutter: 24,
                                  "data-step": "4",
                                  "data-title": "扫码录入",
                                  "data-intro":
                                    "此功能支持扫码枪扫描商品条码进行录入",
                                },
                              },
                              [
                                _vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-button",
                                          { on: { click: _vm.scanEnter } },
                                          [_vm._v("扫码录入")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0 8px 0 12px",
                                        },
                                        attrs: { md: 16, sm: 24 },
                                      },
                                      [
                                        _c("a-input", {
                                          ref: "scanBarCode",
                                          attrs: {
                                            placeholder: "请扫描商品条码并回车",
                                          },
                                          on: {
                                            pressEnter: _vm.scanPressEnter,
                                          },
                                          model: {
                                            value: _vm.scanBarCode,
                                            callback: function ($$v) {
                                              _vm.scanBarCode = $$v
                                            },
                                            expression: "scanBarCode",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0px 12px 0 0",
                                        },
                                        attrs: { md: 6, sm: 24 },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          { on: { click: _vm.stopScan } },
                                          [_vm._v("收起扫码")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "a-row",
                          {
                            staticStyle: {
                              float: "left",
                              "padding-bottom": "5px",
                            },
                            attrs: { gutter: 24 },
                          },
                          [
                            _c(
                              "a-col",
                              { attrs: { md: 24, sm: 24 } },
                              [
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.handleHistoryBillList },
                                  },
                                  [
                                    _c("a-icon", {
                                      attrs: { type: "history" },
                                    }),
                                    _vm._v("历史单据"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.rowCanEdit
                          ? _c(
                              "a-row",
                              {
                                staticStyle: {
                                  float: "left",
                                  "padding-bottom": "5px",
                                  "padding-left": "20px",
                                },
                                attrs: { gutter: 24 },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { icon: "import" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onImport(_vm.prefixNo)
                                      },
                                    },
                                  },
                                  [_vm._v("导入明细")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 24, md: 24, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
                            label: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["remark"],
                                expression: "[ 'remark' ]",
                              },
                            ],
                            staticStyle: { "margin-top": "8px" },
                            attrs: { rows: 1, placeholder: "请输入备注" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "附件",
                            "data-step": "10",
                            "data-title": "附件",
                            "data-intro":
                              "可以上传与单据相关的图片、文档，支持多个文件",
                          },
                        },
                        [
                          _c("j-upload", {
                            attrs: { bizPath: "bill" },
                            model: {
                              value: _vm.fileList,
                              callback: function ($$v) {
                                _vm.fileList = $$v
                              },
                              expression: "fileList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("import-item-modal", {
        ref: "importItemModalForm",
        on: { ok: _vm.importItemModalFormOk },
      }),
      _c("history-bill-list", { ref: "historyBillListModalForm" }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
      _c("bill-print-iframe", { ref: "modalPrint" }),
      _c("bill-print-pro-iframe", { ref: "modalPrintPro" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }